import produce from 'immer';

export interface IOffsiteCampaign {
    brand?: any;
    title: string;
    description: string;
    objectives: string[];
    requirements: string[];
    deliverables: string[];
    platforms: string[];
    participants_count: number;
    feature_image?: string;
    feature_image_preview?: string;
    assets?: string;
    total_budget: number;
    funded?: boolean;
    approved?: boolean;
    available_budget?: number;
    status?: string;
    deleted?: boolean;
    start_date?: string;
    end_date?: string;
    location?: {
        type: string;
        coordinates: number[];
        address?: string;
        description?: string;
    };
    physical_product?: boolean;
}

export const initialState: IOffsiteCampaign = {
    title: '',
    description: '',
    objectives: [],
    requirements: [],
    deliverables: [],
    platforms: [],
    participants_count: 1,
    feature_image: '',
    feature_image_preview: '',
    assets: '',
    total_budget: 0,
    funded: false,
    approved: false,
    available_budget: 0,
    status: 'draft',
    deleted: false,
    start_date: '',
    end_date: '',
    location: {
        type: 'Point',
        coordinates: [],
        address: '',
        description: '',
    },
    physical_product: false,
};

type Action =
    | { type: 'FIELD'; field: string; value: any }
    | { type: 'RESET' }
    | { type: 'SET_STATE'; payload: IOffsiteCampaign };

export const reducer = (state: IOffsiteCampaign = initialState, action: Action): IOffsiteCampaign => {
    switch (action.type) {
        case 'FIELD':
            return produce(state, draft => {
                (draft as any)[action.field] = action.value;
            });
        case 'RESET':
            return initialState;
        case 'SET_STATE':
            return action.payload;
        default:
            return state;
    }
};
